module.exports = function (bwsNotificationService) {
    return {
        restrict: 'E',
        scope: {
            message: '@?'
        },
        link(scope) {
            scope.message = bwsNotificationService.message || '';
        },
        template: require('./bws-notification-template.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/notification/bws-notification-directive.js
 **/